import { itemRoutesApi } from "@/api/endpoints";
import { ReferenceNameMasterPage } from "./ReferenceNameMasterPage";

/** Route-of-administration master (Oral, Intravenous, Topical…) — drives the Route dropdown on items. */
export function ItemRoutesPage() {
  return (
    <ReferenceNameMasterPage
      title="Item Routes"
      noun="Route"
      api={itemRoutesApi}
      queryKey="item-routes"
      permPrefix="catalog.route"
    />
  );
}
